/* NALLI — quantity selector guard (WS7).
 *
 * Ported from the inline <script> at the end of live snippets/quantity-selector.liquid
 * (specs/snippets--quantity-selector.liquid.md hunk 5), externalized and made
 * delegation-based so it survives morphs / late-rendered selectors.
 *
 * Enforces the `data-productmax` clamp emitted by the WS7 core edit to
 * snippets/quantity-selector.liquid (summed variant inventory; vouchers 1000;
 * untracked variants contribute 100):
 *   - disables the minus button at min (fabric min = 3)
 *   - disables the plus button at/above data-productmax and shows the
 *     "Only N pieces available in stock." warning
 *
 * The Fall & Edging handler in nalli-buy-buttons.js rewrites
 * input.dataset.productmax when the checkbox toggles; this guard reads it live
 * on every tick, so the cap follows automatically.
 */

function applyUIState(selector) {
  const minusBtn = selector.querySelector('.quantity-minus');
  const plusBtn = selector.querySelector('.quantity-plus');
  const input = selector.querySelector('input[type="number"]');
  const warning = selector.querySelector('.quantity-warning');
  if (!input || !minusBtn || !plusBtn) return;

  const min = input.min ? parseInt(input.min, 10) : 1;
  const max = input.dataset.productmax
    ? parseInt(input.dataset.productmax, 10)
    : Number.POSITIVE_INFINITY;
  const value = parseInt(input.value || String(min), 10);

  minusBtn.disabled = value <= min;

  if (Number.isFinite(max) && value >= max) {
    plusBtn.disabled = true;
    if (warning) warning.style.display = 'block';
  } else {
    plusBtn.disabled = false;
  }
}

function handle(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const selector = target.closest('quantity-selector-component');
  if (!selector) return;

  if (event.type === 'click') {
    // Run right after the theme's own +/- handler mutates the input.
    setTimeout(() => applyUIState(selector), 0);
  } else {
    applyUIState(selector);
  }
}

document.addEventListener('input', handle);
document.addEventListener('change', handle);
document.addEventListener('click', handle);

function initAll() {
  document.querySelectorAll('quantity-selector-component').forEach(applyUIState);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
